<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="row mt-4">
  <div class="col-12 pt-3 mb-3">
    <button #btnAdicionarExecutora (click)="adicionarAssinatura()" data-toggle="modal" data-target="#dialogAssinatura"
      class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar assinatura
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="listaAssinaturas && listaAssinaturas.length > 0">
  <thead>
    <tr>
      <th scope="col">Data limite</th>
      <th scope="col">Prefeito</th>
      <th scope="col">Contador</th>
      <th scope="col">Tesoureiro</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaAssinaturas; let idx = index">
      <td>{{item.data_limite | date:'dd/MM/yyyy':'GMT'}}</td>
      <td>{{item.prefeito}}</td>
      <td>{{item.contador}}</td>
      <td>{{item.tesoureiro}}</td>
      <td class="text-right" style="min-width: 150px;">
        <button #btnEditarAssinatura (click)="editarAssinatura(item)" data-toggle="modal"
          data-target="#dialogAssinatura" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button (click)="removerAssinatura(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>

<div #modal class="modal fade" id="dialogAssinatura" tabindex="-1" role="dialog" aria-labelledby="assinatura"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <img src="assets/img/signature.png" alt="" height="32px" width="32px" class="float-left mr-2">
        <h5 class="modal-title">ASSINATURAS</h5>
        <br />
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #f="ngForm" id="form_" novalidate="" autocomplete="off">
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <label for="data_limite">Data limite<span class="text-danger">*</span></label>
              <p-calendar #inputData id="data_limite" [(ngModel)]="entity.data_limite"
                [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="date"
                dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
                [style]="{ width: '100%' }" inputId="data_limite">
              </p-calendar>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <p-fieldset legend="Prefeito">
                <div class="form-row">
                  <label for="nome" class="col-2 col-form-label">Nome<span class="text-danger">*</span></label>
                  <div class="form-group col-10">
                    <input [(ngModel)]="entity.prefeito" type="text" ngModel name="prefeito"
                      class="form-control form-control-sm font-weight-bold" id="prefeito">
                  </div>
                </div>
                <div class="form-row">
                  <label for="nome" class="col-2 col-form-label">Cargo<span class="text-danger">*</span></label>
                  <div class="form-group col-10">                    
                    <input [(ngModel)]="entity.cargo_prefeito" type="text" ngModel name="cargo_prefeito"
                      class="form-control form-control-sm font-weight-bold" id="cargo_prefeito">
                  </div>
                </div>
              </p-fieldset>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <p-fieldset legend="Contador">
                <div class="form-row">
                  <label for="nome" class="col-2 col-form-label">Nome<span class="text-danger">*</span></label>
                  <div class="form-group col-10">                   
                    <input [(ngModel)]="entity.contador" type="text" ngModel name="contador"
                      class="form-control form-control-sm font-weight-bold" id="contador">
                  </div>
                </div>
                <div class="form-row">
                  <label for="nome" class="col-2 col-form-label">Cargo<span class="text-danger">*</span></label>
                  <div class="form-group col-10">                    
                    <input [(ngModel)]="entity.cargo_contador" type="text" ngModel name="cargo_contador"
                      class="form-control form-control-sm font-weight-bold" id="cargo_contador">
                  </div>
                </div>
              </p-fieldset>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <p-fieldset legend="Tesoureiro">
                <div class="form-row">
                  <label for="nome" class="col-2 col-form-label">Nome<span class="text-danger">*</span></label>
                  <div class="form-group col-10">                   
                    <input [(ngModel)]="entity.tesoureiro" type="text" ngModel name="tesoureiro"
                      class="form-control form-control-sm font-weight-bold" id="tesoureiro">
                  </div>
                </div>
                <div class="form-row">
                  <label for="nome" class="col-2 col-form-label">Cargo<span class="text-danger">*</span></label>
                  <div class="form-group col-10">                    
                    <input [(ngModel)]="entity.cargo_tesoureiro" type="text" ngModel name="cargo_tesoureiro"
                      class="form-control form-control-sm font-weight-bold" id="cargo_tesoureiro">
                  </div>
                </div>
              </p-fieldset>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button [disabled]="!f.valid || !f.dirty" type="submit" (click)="salvarAssinatura(f.value)"
            class="btn btn-primary" id="btnSalvar">Salvar</button>
          <button #btnCancelarAssinatura type="button" class="btn btn-link" id="btnCancelar"
            (click)="cancelarAssinatura()" data-dismiss="modal">Cancelar</button>
          <button #btnFecharAssinatura type="button" class="btn btn-link" id="btnFechar" data-dismiss="modal"
            style="display: none">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</div>